import * as net from 'util/Net';

import {BenchlingAppDefinitionGraphQL as AppDefinition} from '../../graphql-fragments/benchling-apps/__generated/BenchlingAppDefinitionGraphQL';
import {BenchlingAppGraphQL as AppInstallation} from '../../graphql-fragments/benchling-apps/__generated/BenchlingAppGraphQL';
import {Audience, DEFAULT_APP_VERSION} from './BenchlingAppDAO';

export interface AppdefinitionVersionResponse {
  benchlingAppDefinition: string;
  version: string;
}

export interface ShareAppDefinitionVersionArgs {
  appDefinitionId: string;
  version: string;
  allowList: Array<string>;
}
const APP_DEFINITIONS_URL = '/1/api/app-definitions';

export function shareAppDefinitionVersionWithAllowlist(
  data: ShareAppDefinitionVersionArgs
): Promise<AppdefinitionVersionResponse> {
  return net.postJSONPromise({
    url: `${APP_DEFINITIONS_URL}/${data.appDefinitionId}/versions:share`,
    data: {
      version: data.version,
      allowList: data.allowList,
    },
  });
}

export function createBenchlingAppDefinition(data: {
  name: string;
  description: string;
  audience: Audience;
}): Promise<{benchlingAppDefinition: AppDefinition}> {
  return net.postJSONPromise({
    url: `${APP_DEFINITIONS_URL}`,
    data,
  });
}

export function createBenchlingAppDefinitionFromManifest(data: {
  location: string;
  audience: Audience;
}): Promise<{benchlingAppDefinition: AppDefinition}> {
  return net.postJSONPromise({
    url: `${APP_DEFINITIONS_URL}/manifest`,
    data,
  });
}

export function updateBenchlingAppDefinition(
  appDefinitionId: string,
  data: {
    webhookUrl?: string | null;
    publicKey?: string | null;
    webhookHeaders?: Array<{key: string; value: string}> | null;
  }
): Promise<{benchlingAppDefinition: AppDefinition}> {
  return net.patchJSONPromise({
    url: `${APP_DEFINITIONS_URL}/${appDefinitionId}`,
    data,
  });
}

export function setBenchlingAppDefinitionRedirectUris(
  appDefinitionId: string,
  data: {
    redirectUris: Array<string>;
  }
): Promise<{redirectUris: Array<string>}> {
  return net.putJSONPromise({
    url: `${APP_DEFINITIONS_URL}/${appDefinitionId}/oauth2-redirect-uris`,
    data,
  });
}

export function updateBenchlingAppDefinitionVersion(
  appDefinitionId: string,
  version: string | null,
  data: {
    name?: string;
    description?: string;
    allowList?: Array<string>;
    versionToInheritFrom?: string;
  }
): Promise<{benchlingAppDefinition: AppDefinition}> {
  return net.patchJSONPromise({
    url: `${APP_DEFINITIONS_URL}/${appDefinitionId}/versions/${version ?? DEFAULT_APP_VERSION}`,
    data,
  });
}

export function updateBenchlingAppDefinitionVersionFromManifest(
  appDefinitionId: string,
  version: string | null,
  data: {
    location: string;
  }
): Promise<{benchlingAppDefinition: AppDefinition; version: string}> {
  return net.patchJSONPromise({
    url: `${APP_DEFINITIONS_URL}/${appDefinitionId}/versions/${version ?? DEFAULT_APP_VERSION}/manifest`,
    data,
  });
}

export function installAppDefinitionVersionOnHomeTenant(
  appDefinitionId: string,
  version: string
): Promise<{benchlingApp: AppInstallation}> {
  return net.postJSONPromise({
    url: `${APP_DEFINITIONS_URL}/${appDefinitionId}/versions/${version}:install-on-home-tenant`,
  });
}
